import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import Reveal from '../reveal/reveal';
import styles from './socialProofStrip.module.scss';

function SocialProofStrip({
  headline,
  headlineMobile,
  statsItems = [],
  logos = [],
  enableAnimations = false,
}) {
  return (
    <div className={styles.socialProofStrip}>
      <div className={styles.container}>
        {(headline || headlineMobile) && (
          <Reveal
            as="h2"
            variant="up"
            enabled={enableAnimations}
            className={styles.headline}
          >
            {headline && (
              <span className={styles.desktopHeadline}>{parse(headline)}</span>
            )}
            {headlineMobile && (
              <span className={styles.mobileHeadline}>
                {parse(headlineMobile)}
              </span>
            )}
          </Reveal>
        )}

        {statsItems.length > 0 && (
          <div className={styles.statsContainer}>
            {statsItems.map((item, index) => {
              const hasIconBefore = item.icon && item.iconPosition === 'before';
              const wrapperClassName = hasIconBefore
                ? `${styles.statDescriptionWrapper} ${styles.iconBefore}`
                : styles.statDescriptionWrapper;

              return (
                <Reveal
                  key={`stat-${item.stat}-${item.description}`}
                  variant="up"
                  delay={index * 120}
                  enabled={enableAnimations}
                  className={styles.statItem}
                >
                  <div className={styles.stat}>{item.stat}</div>
                  <div className={wrapperClassName}>
                    {item.description && (
                      <div className={styles.statDescription}>
                        {hasIconBefore && (
                          <img
                            src={item.icon.src}
                            alt={item.icon.alt || ''}
                            className={styles.statIcon}
                            width={item.icon.width}
                            height={item.icon.height}
                          />
                        )}
                        {parse(item.description)}
                      </div>
                    )}
                    {item.icon && item.iconPosition === 'after' && (
                      <img
                        src={item.icon.src}
                        alt={item.icon.alt || ''}
                        className={styles.statIcon}
                        width={item.icon.width}
                        height={item.icon.height}
                      />
                    )}
                  </div>
                </Reveal>
              );
            })}
          </div>
        )}

        {logos.length > 0 && (
          <Reveal
            variant="fade"
            delay={120}
            enabled={enableAnimations}
            className={styles.logosContainer}
          >
            {logos.map((logo) => (
              <img
                key={`logo-${logo.src}`}
                src={logo.src}
                alt={logo.alt || ''}
                className={styles.logo}
                width={logo.width}
                height={logo.height}
              />
            ))}
          </Reveal>
        )}
      </div>
    </div>
  );
}

SocialProofStrip.propTypes = {
  headline: PropTypes.string,
  headlineMobile: PropTypes.string,
  statsItems: PropTypes.arrayOf(
    PropTypes.shape({
      stat: PropTypes.string,
      description: PropTypes.string,
      icon: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
      }),
      iconPosition: PropTypes.string,
    })
  ),
  logos: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number,
    })
  ),
  enableAnimations: PropTypes.bool,
};

export default SocialProofStrip;
